import { ActionMap } from "library/ActionMap";

export enum Status {
  INITIAL = "INITIAL",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  EXPIRED_OTP = "EXPIRED_OTP",
  EXPIRED_OTP_SUCCESS = "EXPIRED_OTP_SUCCESS",
}
export type State =
  | {
      status:
        | Status.INITIAL
        | Status.SUCCESS
        | Status.ERROR
        | Status.EXPIRED_OTP_SUCCESS;
    }
  | {
      status: Status.EXPIRED_OTP;
      token: string;
      createSessionUrl: string;
    };

export type PhoneNumbersFormValues = {
  number: string;
};

export enum ActionTypes {
  BACK = "BACK",
  EXPIRED_OTP = "EXPIRED_OTP",
  EXPIRED_OTP_SUCCESS = "EXPIRED_OTP_SUCCESS",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  OTP_EXCEEDED_ALLOWED_LIMITS = "OTP_EXCEEDED_ALLOWED_LIMITS",
}

export type Payloads = {
  [ActionTypes.EXPIRED_OTP]: {
    payload: { createSessionUrl: string; token: string; number: string };
  };
  [ActionTypes.OTP_EXCEEDED_ALLOWED_LIMITS]: {
    payload: { title: string; message: string };
  };
};

export type Actions = ActionMap<ActionTypes, Payloads>;
